import { report } from '../buryingPoint/index';

export function headButton (index, val, doAction, axios, miloLogin) {
	if (val.type === 'link') {
		window.location.href = val.value;
	} else if (val.type === 'received') {
		receiveGift(val.type, val.value, doAction);
	} else if (val.type === 'download') {
		miloLogin().then(LoginManager => {
			LoginManager.checkLogin(
				userInfo => {
					const url = download(axios, val.value);
					console.log(url);
					url.then(url => {
						window.location.href = url;
					});
					report('12015');
				},
				() => {
					alert('请先登录');
					report('12023');
				}
			);
		});
	}
}

function receiveGift (actionType, actionValue, doAction) {
	doAction(actionType, actionValue)
		.then(({ sPackageName, iPackageId }) => {
			if (sPackageName) {
				alert(`恭喜你获得了${sPackageName}，请到游戏中查收`);
			}
		})
		.catch(e => {
			console.log(e);
			alert(e.sMsg);
		});
}

function download (axios, name) {
	return new Promise((resolve, reject) => {
		axios
			.get('https://apps.xinyue.qq.com/Dev/opt/get_pkg_msg', {
				params: { androidPkgName: name }
			})
			.then(res => {
				if (res.data.status === '200') {
					const isAndroid = /linux|android/gi.test(
						navigator.userAgent.toLowerCase()
					);
					const isiOS = /ipad|iphone|ipod/gi.test(
						navigator.userAgent.toLowerCase()
					);
					let url = '';
					if (isAndroid) {
						url = res.data.msg.androidDownloadUrl;
					} else if (isiOS) {
						url = res.data.msg.IOSDownloadUrl;
					}
					resolve(url);
				}
			})
			.catch(e => {
				console.log(e);
				alert('获取游戏信息失败');
				reject(e);
			});
	});
}



// WEBPACK FOOTER //
// ./src/components/actModules/h5/templates/banner/index.js